import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('yotpoLoyalty'),
  titleToNamespace: true,
  avatarPath: avatars.yotpo,
  logoPath: logos.yotpo,
  hasConnectionStatus: false
});
